<template>
  <div>
    <div class="coverageReport-title">
      <div>{{ $t('Bill.ResourceOptimization.coverageRate') }}</div>
      <div></div>
    </div>
    <div class="coverageReport-top">
      <coverage-report-search></coverage-report-search>
    </div>
    <table-coverage-report></table-coverage-report>
  </div>
</template>

<script>
import CoverageReportSearch from "../coverage_report/CoverageReportSearch";
import TableCoverageReport from "../coverage_report/TableCoverageReport";

export default {
  name: "CoverageReport",
  components: {
    CoverageReportSearch,
    TableCoverageReport,
  },
};
</script>

<style scoped>
.coverageReport-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 8px 4px;
  font-weight: 600;
  overflow: hidden;
}
.coverageReport-title > div:nth-child(1) {
  float: left;
}
.coverageReport-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.coverageReport-top {
  width: 100%;
  height: 53px;
}
</style>



// WEBPACK FOOTER //
// src/components/ebilling/reserved_instance/coverage_report/CoverageReport.vue